import styled from 'styled-components';
import { Modal } from 'antd';

export const RevisionOfProjectModal = styled(Modal)`
  & .ant-modal-body {
    width: 100%;
    margin: 0;
    padding: 0;
  }

  & .ant-modal-content {
    padding: 1rem;
    border-radius: 0.25rem;
  }

  & .ant-modal-header {
    border-bottom: none;
    padding: 0px;

    & > .ant-modal-title > div.revision-of-project-header {
      & > .title {
        font-size: 1.125rem;
        font-weight: 700;
        text-align: left;
        color: ${({ theme }) => theme.colors.grayDark2};
      }

      & > .text {
        font-size: 0.75rem;
        font-weight: 400;
        text-align: left;
      }

      & > div.file {
        & > span {
          font-size: 0.75rem;
          font-weight: 400;
          text-align: left;
        }
      }
    }
  }

  & .ant-modal-footer {
    border-top: none;
    padding: 0px;
    margin-top: 1rem;
  }
`;

export const RevisionOfProjectRowContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const RevisionOfProjectRowContainerFacelift = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: 0;
  padding: 0;
`;

export const DataInputContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: none;

  & > .subtitle {
    color: ${({ theme }) => theme.colors.grayDark2};
    font-weight: bold;
    font-size: 0.875rem;
    display: flex;
  }

  & > .ant-select,
  .ant-input {
    margin-right: 1rem;
    width: 15.938rem;
    height: 2rem;
    font-size: 0.75rem;

    & > .ant-select-selector {
      border-radius: 0.25rem;
    }
  }
`;

export const DataInputContainerFacelift = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  padding: none;
  gap: 1rem;
`;

export const TitleProject = styled.span``;
